import { round } from "@repo/system";

type ProportionalLine = { basketId: string; totalPrice: number };

/**
 * Splits `totalDiscount` across lines by each line's share of `totalUnit`;
 * rounding residual lands on the first line. Minimal `{ basketId, totalPrice }`
 * shape so both POS and kiosk lines use it.
 *
 * @param lines eligible lines
 * @param totalUnit summed total of eligible lines
 * @param totalDiscount discount to distribute
 */
export function calculateProportionalDiscount<T extends ProportionalLine>(
  lines: T[],
  totalUnit: number,
  totalDiscount: number
): { basketId: string; amount: number }[] {
  let totalGivenDiscount = 0;
  const lineDiscounts = lines.map((line) => {
    if (line.totalPrice === 0) {
      return { basketId: line.basketId, amount: 0 };
    }

    const proportion = line.totalPrice / totalUnit;
    const amount = round(totalDiscount * proportion, 0);
    totalGivenDiscount += amount;

    return { basketId: line.basketId, amount };
  });

  if (lineDiscounts.length > 0) {
    lineDiscounts[0].amount += totalDiscount - totalGivenDiscount;
  }

  return lineDiscounts;
}
